import { c as _c } from "react/compiler-runtime";
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import Image from 'next/image';
import * as RadoslawLogos from '../../mentorzy/radoslaw-mysliwiec/_svg';
import * as Logos from './_svg';
type TechnologyCardProps = {
  technology: {
    name: string;
    urlIcon?: string;
  };
};

/* FALLBACK FOR TECHNOLOGIES WITHOUT ICONS IN DATABASE */
const TECHNOLOGY_LOGOS = {
  Python: Logos.PythonLogo,
  'C#': Logos.CSharpLogo,
  Next: Logos.NextLogo,
  TRPC: Logos.TRPCLogo,
  // Radoslaw Mysliwiec technologies
  C: RadoslawLogos.C,
  'C++': RadoslawLogos.Cpp,
  JavaScript: RadoslawLogos.JavaScript,
  TypeScript: RadoslawLogos.TypeScript,
  SQL: RadoslawLogos.SQL,
  'Node.js': RadoslawLogos.Node,
  PostgreSQL: RadoslawLogos.PostgreSQL,
  React: RadoslawLogos.React,
  'Next.js': RadoslawLogos.Next,
  'React Query': RadoslawLogos.ReactQuery,
  TailwindCSS: RadoslawLogos.Tailwind,
  tRPC: RadoslawLogos.TRPC,
  DrizzleORM: RadoslawLogos.Drizzle,
  Bash: RadoslawLogos.Bash,
  Docker: RadoslawLogos.Docker,
  Git: RadoslawLogos.Git,
  GitHub: RadoslawLogos.GitHub,
  Vercel: RadoslawLogos.Vercel,
  Cursor: RadoslawLogos.Cursor,
  'Claude Code': RadoslawLogos.Claude,
  Coolify: RadoslawLogos.Coolify
};
export function TechnologyCard(t0) {
  const $ = _c(9);
  const {
    technology
  } = t0;
  const LogoComponent = TECHNOLOGY_LOGOS[technology.name as keyof typeof TECHNOLOGY_LOGOS];
  let t1;
  if ($[0] !== LogoComponent || $[1] !== technology.name || $[2] !== technology.urlIcon) {
    t1 = technology.urlIcon ? <Image src={technology.urlIcon} alt={`${technology.name} logo`} width={48} height={48} className="h-12 w-12" unoptimized={true} /> : LogoComponent && <LogoComponent size={12} />;
    $[0] = LogoComponent;
    $[1] = technology.name;
    $[2] = technology.urlIcon;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== technology.name) {
    t2 = <P3 className="text-blue-700">{technology.name}</P3>;
    $[4] = technology.name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex aspect-square w-32 flex-col items-center justify-center gap-2 rounded-sm border border-blue-100 bg-blue-50 p-4 text-center">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}